import { render, staticRenderFns } from "./GmbServicePreview.vue?vue&type=template&id=59b04ae6&scoped=true&"
import script from "./GmbServicePreview.vue?vue&type=script&lang=js&"
export * from "./GmbServicePreview.vue?vue&type=script&lang=js&"
import style0 from "./GmbServicePreview.vue?vue&type=style&index=0&id=59b04ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b04ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
